import { productSellthrough } from "./productAnalysisModel";

export const sellthroughSeasons = ["2025 YAZ", "2025 KIŞ", "2026 YAZ", "2026 KIŞ"] as const;
export const defaultSellthroughSeason = "2026 KIŞ";
export type SellthroughProduct = {
  label: string; category: string; season: string;
  import_units: number; sales_units: number; stock_units: number;
  sellthrough_percent: number | null;
};
export type SellthroughTotal = {
  label: string; sku_count: number; import_units: number;
  sales_units: number; stock_units: number; sellthrough_percent: number | null;
};
export function sellthroughTotal(label: string, products: SellthroughProduct[]): SellthroughTotal {
  const totals = products.reduce((sum, row) => ({
    import_units: sum.import_units + row.import_units,
    sales_units: sum.sales_units + row.sales_units,
    stock_units: sum.stock_units + row.stock_units,
  }), { import_units: 0, sales_units: 0, stock_units: 0 });
  return { label, sku_count: products.length, ...totals,
    sellthrough_percent: productSellthrough(totals.sales_units, totals.stock_units) };
}
export function sellthroughCategories(products: SellthroughProduct[], season: string): SellthroughTotal[] {
  const grouped = new Map<string, SellthroughProduct[]>();
  for (const row of products) {
    if (row.season !== season) continue;
    const bucket = grouped.get(row.category) ?? [];
    bucket.push(row); grouped.set(row.category, bucket);
  }
  return [...grouped].map(([label, rows]) => sellthroughTotal(label, rows));
}
export type SellthroughSort = { key: "label" | "sku_count" | "import_units" | "sales_units" | "stock_units" | "sellthrough_percent"; direction: "asc" | "desc" };
export function sortSellthrough<T extends { label: string }>(rows: T[], sort: SellthroughSort): T[] {
  return [...rows].sort((a, b) => {
    const av = a[sort.key as keyof T], bv = b[sort.key as keyof T];
    if (av == null || bv == null) return av == null && bv == null ? a.label.localeCompare(b.label, "tr") : av == null ? 1 : -1;
    const delta = typeof av === "number" && typeof bv === "number" ? av - bv : String(av).localeCompare(String(bv), "tr", { numeric: true });
    return delta * (sort.direction === "asc" ? 1 : -1) || a.label.localeCompare(b.label, "tr");
  });
}
